import React from "react";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import Loader from "../Loader/Loader";
import { useAppContext } from "../../Lib/ContextLib";

export default function LivePlayerApp() {
  const { accessObject } = useAppContext();
  const [dataRows, setdataRows] = React.useState([]);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(true);
  // const [filteredData, setFilteredData] = React.useState([]);

  React.useEffect(() => {
    getBranch();
  }, []);

  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/dashboard/all-socket-live-player`, {
      method: "GET",
      credentials: "include",
    })
      .then(function (response) {
        setLoader(false);

        setdataRows(response.data.livePlayerGame);
        // setFilteredData(filteredBooks);
      })
      .catch(function (error) {
        console.log("getBranch error :::", error);
        setLoader(false);
      });
  };

  // const filterData = (str) => {
  //   const emailRegex = /\S+@\S+\.\S+/;
  //   const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
  //   return emailRegex.test(str) || phoneRegex.test(str);
  // };

  // // Event handler for filtering the data
  // const handleFilter = (event) => {
  //   const searchQuery = event.target.value;
  //   console.log("tableData::: ", dataRows);
  //   const filtered = dataRows

  //     .filter((item) => filterData(item.email) || filterData(item.phoneNo))
  //     .filter((item) => {
  //       item.playerStatus == "banned" &&
  //         (item.email.includes(searchQuery) ||
  //           item.phoneNo.includes(searchQuery));
  //     });
  //   setFilteredData(filtered);
  // };

  return (
    <div>
      <div className="content p-3">
        <div class="card ">
          <div
            class="pl-4 pr-4 pt-4"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <h3 class="card-title">
              <b>Live Player Game</b>
            </h3>
            <div>
              {/* <input
                class="input-simple"
                type="text"
                placeholder="Email And Phone No"
                onChange={handleFilter}
                // value={searchPhoneNo}
                // onChange={(e) => setSearchPhoneNo(e.target.value)}
              /> */}
            </div>
          </div>

          <div class="card-body" style={{ overflow: "scroll" }}>
            <table id="" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" style={{ textAlign: "center" }}>
                    SrNo
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Date
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Name
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Email
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Balance
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Join Date
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Status
                  </th>
                </tr>
              </thead>
              {accessObject?.getLivePlayerGameList == true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {dataRows?.length > 0 ? (
                          <>
                            {dataRows
                              ?.slice(pagination.start, pagination.end)
                              .map((row, index) => (
                                <>
                                  <tr
                                    key={index}
                                    style={{ textAlign: "center" }}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      {index + 1 + pagination.start}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(row.createdAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.name}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.email || "-"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.balance}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(row.createdAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.playerStatus}
                                    </td>
                                  </tr>
                                </>
                              ))}
                          </>
                        ) : (
                          <>
                            <tr>
                              <td colSpan={8}>
                                <h5 className="text-center">
                                  No Data Available
                                </h5>
                              </td>
                            </tr>
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={8}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getLivePlayerGameList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {dataRows?.length != 0 && (
            <Pagination
              updateShowPerpagevalue={updateShowPerpagevalue}
              showPrePage={showPrePage}
              onPaginationChange={onPaginationChange}
              total={dataRows?.length}
            />
          )}
        </div>
      </div>
    </div>
  );
}
